<div class="row">
  <div class="col-12 col-md-6">
    @if (calcService.nettoMonthly() > 0) {
    <div class="result-summary mb-4">
      <div class="netto-display">
        <span class="label">Dein Nettogehalt</span>
        <span class="netto-amount">{{ calcService.nettoMonthly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }} / Monat</span>
        <span class="brutto-ref">{{ calcService.nettoYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }} / Jahr</span>
      </div>
    </div>
    } @if (calcService.nettoMonthly() <= 0) {
    <div>
      <h2 class="welcome">Brutto-Netto-Rechner</h2>
      <div class="info-paragraph mb-3">
        <div class="icon me-3"><i class="fa-solid fa-calculator fa-3x"></i></div>
        <p>
          Berechne schnell und einfach dein <b>Nettogehalt</b> aus deinem Bruttogehalt. Der Rechner berücksichtigt Lohnsteuer, Solidaritätszuschlag, Kirchensteuer sowie alle
          Sozialversicherungsbeiträge (Renten-, Arbeitslosen-, Kranken- und Pflegeversicherung).
        </p>
      </div>
      <div class="info-paragraph mb-3">
        <div class="icon me-3"><i class="fa-solid fa-triangle-exclamation fa-3x"></i></div>
        <p>
          <b>Disclaimer:</b> Dieser Rechner liefert eine Näherung auf Basis der aktuellen Steuerparameter (§32a EStG) und Sozialversicherungsbeitragssätze. Das tatsächliche
          Nettogehalt kann aufgrund individueller Freibeträge, privater Krankenversicherung oder sonstiger Besonderheiten abweichen.
        </p>
      </div>
    </div>
    }

    <!-- Results Table -->
    @if (calcService.nettoMonthly() > 0) {
    <table class="table table-sm">
      <thead>
        <tr>
          <th></th>
          <th scope="col" class="text-end">Monatlich</th>
          <th scope="col" class="text-end">Jährlich</th>
        </tr>
      </thead>
      <tbody class="table-group-divider">
        <tr>
          <th scope="row">Bruttogehalt</th>
          <td class="text-end">{{ calcService.state.bruttoMonthly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end">{{ calcService.bruttoYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        @if (calcService.state.geldwerterVorteil() > 0) {
        <tr>
          <th scope="row">Geldwerter Vorteil</th>
          <td class="text-end">{{ calcService.state.geldwerterVorteil() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end">{{ calcService.state.geldwerterVorteil() * 12 | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        <tr class="subtotal">
          <th scope="row">Bemessungsgrundlage</th>
          <td class="text-end">{{ calcService.assessmentBasis() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end">{{ calcService.assessmentBasis() * 12 | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        }
      </tbody>
      <tbody class="table-group-divider">
        <tr class="section-header">
          <th scope="row" colspan="3">Sozialversicherung</th>
        </tr>
        @if (calcService.state.gesetzlichRentenversichert()) {
        <tr>
          <th scope="row">Rentenversicherung ({{ (calcService.state.taxParams()?.socialSecurity?.rentenversicherung?.employeeRate ?? 0) * 100 | number : '1.1-1' : 'de-DE' }}%)</th>
          <td class="text-end deduction">-{{ calcService.rentenversicherung() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.rentenversicherungYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        } @if (calcService.state.gesetzlichArbeitslosenversichert()) {
        <tr>
          <th scope="row">
            Arbeitslosen&shy;versicherung ({{ (calcService.state.taxParams()?.socialSecurity?.arbeitslosenversicherung?.employeeRate ?? 0) * 100 | number : '1.1-1' : 'de-DE' }}%)
          </th>
          <td class="text-end deduction">-{{ calcService.arbeitslosenversicherung() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.arbeitslosenversicherungYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        } @if (calcService.state.krankenversicherungsArt() === 'privat') {
        <tr>
          <th scope="row">Private Krankenversicherung (inkl. PPV)</th>
          <td class="text-end deduction">-{{ calcService.krankenversicherung() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.krankenversicherungYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        } @else {
        <tr>
          <th scope="row">Krankenversicherung</th>
          <td class="text-end deduction">-{{ calcService.krankenversicherung() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.krankenversicherungYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        <tr>
          <th scope="row">Pflegeversicherung</th>
          <td class="text-end deduction">-{{ calcService.pflegeversicherung() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.pflegeversicherungYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        }
        <tr class="subtotal">
          <th scope="row">Sozialversicherung gesamt</th>
          <td class="text-end deduction">-{{ calcService.socialSecurityTotal() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.socialSecurityTotalYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
      </tbody>
      <tbody class="table-group-divider">
        <tr class="section-header">
          <th scope="row" colspan="3">Steuern</th>
        </tr>
        <tr>
          <th scope="row">Lohnsteuer</th>
          <td class="text-end deduction">-{{ calcService.lohnsteuer() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.lohnsteuerYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        <tr>
          <th scope="row">Solidaritätszuschlag</th>
          <td class="text-end deduction">-{{ calcService.solidaritaetszuschlag() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.solidaritaetszuschlagYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        @if (calcService.kirchensteuer() > 0) {
        <tr>
          <th scope="row">Kirchensteuer</th>
          <td class="text-end deduction">-{{ calcService.kirchensteuer() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.kirchensteuerYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        }
        <tr class="subtotal">
          <th scope="row">Steuern gesamt</th>
          <td class="text-end deduction">-{{ calcService.taxesTotal() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.taxesTotalYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
      </tbody>
      <tfoot class="table-group-divider">
        <tr>
          <th scope="row">Abzüge gesamt</th>
          <td class="text-end deduction">-{{ calcService.totalDeductions() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end deduction">-{{ calcService.totalDeductionsYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
        <tr class="netto-row">
          <th scope="row">Nettogehalt</th>
          <td class="text-end netto">{{ calcService.nettoMonthly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
          <td class="text-end netto">{{ calcService.nettoYearly() | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</td>
        </tr>
      </tfoot>
    </table>

    @if (calcService.generatedUrl()) {
    <div class="mt-3">
      <span class="copy" [cdkCopyToClipboard]="calcService.generatedUrl()" (cdkCopyToClipboardCopied)="copied($event)">
        Link zur Berechnung in Zwischenablage kopieren
        <i class="fa-regular fa-clone"></i>
      </span>
    </div>
    } }
  </div>

  <div class="col-12 col-md-6">
    <form [formGroup]="form">
      <!-- Abrechnungsjahr -->
      <mat-form-field appearance="outline" class="w-100 mb-2" subscriptSizing="dynamic">
        <mat-label>Abrechnungsjahr</mat-label>
        <mat-select formControlName="year">
          @for (yearOption of availableYears(); track yearOption.year) {
          <mat-option [value]="yearOption.year">
            {{ yearOption.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Gehaltseingabe: Monatlich / Jährlich -->
      <div class="mb-3">
        <mat-radio-group formControlName="salaryMode" class="salary-mode-toggle">
          <mat-radio-button value="monthly" class="me-3">Monatsgehalt</mat-radio-button>
          <mat-radio-button value="yearly">Jahresgehalt</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Bruttogehalt ({{ isMonthlyMode ? 'monatlich' : 'jährlich' }})</mat-label>
        <input formControlName="brutto" type="number" matInput [placeholder]="isMonthlyMode ? 'z.B. 4000' : 'z.B. 48000'" />
        <mat-icon matSuffix><i class="fa-solid fa-euro-sign me-3"></i></mat-icon>
        @if (form.get('brutto')?.errors) {
        <mat-hint class="error">Bitte einen gültigen Betrag eingeben</mat-hint>
        }
      </mat-form-field>

      <!-- Geldwerter Vorteil -->
      <mat-form-field appearance="outline" class="w-100 mb-4">
        <mat-label>Geldwerter Vorteil (monatlich)</mat-label>
        <input formControlName="geldwerterVorteil" type="number" matInput placeholder="z.B. 300" />
        <mat-icon matSuffix><i class="fa-solid fa-euro-sign me-3"></i></mat-icon>
        <mat-hint>z.B. Dienstwagen, Jobticket – erhöht die Bemessungsgrundlage für SV und Steuern</mat-hint>
      </mat-form-field>

      <!-- Steuerklasse -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Steuerklasse</mat-label>
        <mat-select formControlName="steuerklasse">
          @for (stk of steuerklassen; track stk) {
          <mat-option [value]="stk"> Steuerklasse {{ stk }} </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Bundesland (wirkt sich auf PV und ggf. Kirchensteuer aus) -->
      <mat-form-field appearance="outline" class="w-100 mb-4">
        <mat-label>Bundesland</mat-label>
        <mat-select formControlName="bundesland">
          @for (land of bundeslaender; track land.key) {
          <mat-option [value]="land.key">
            {{ land.name }}
          </mat-option>
          }
        </mat-select>
        <mat-hint>Beeinflusst Pflegeversicherung (Sachsen: +0,5 %) und ggf. Kirchensteuer</mat-hint>
      </mat-form-field>

      <!-- Krankenversicherung -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Krankenversicherung</mat-label>
        <mat-select formControlName="krankenversicherungsArt">
          @for (kvArt of krankenversicherungsArten; track kvArt.key) {
          <mat-option [value]="kvArt.key">
            {{ kvArt.label }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (isPrivatKrankenversichert) {
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>PKV-Beitrag (Arbeitnehmeranteil monatlich)</mat-label>
        <input formControlName="privatKvBeitrag" type="number" matInput placeholder="z.B. 350" />
        <mat-icon matSuffix><i class="fa-solid fa-euro-sign me-3"></i></mat-icon>
        <mat-hint>Dein monatlicher Eigenanteil inkl. Pflegeversicherung</mat-hint>
      </mat-form-field>
      } @if (showKvZusatzbeitrag) {
      <!-- KV-Zusatzbeitrag -->
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>KV-Zusatzbeitrag</mat-label>
        <input formControlName="kvZusatzbeitrag" type="number" matInput placeholder="2.9" step="0.1" />
        <mat-icon matSuffix><i class="fa-solid fa-percent me-3"></i></mat-icon>
        @if (form.get('kvZusatzbeitrag')?.errors) {
        <mat-hint class="error">Wert zwischen 0% und 5%</mat-hint>
        }
      </mat-form-field>
      }

      <!-- Kirchensteuer -->
      <div class="mb-1">
        <mat-checkbox formControlName="kirchensteuer">Kirchensteuer</mat-checkbox>
      </div>

      <!-- Rentenversicherung / Arbeitslosenversicherung -->
      <div class="mb-1">
        <mat-checkbox formControlName="gesetzlichRentenversichert">Gesetzlich rentenversichert</mat-checkbox>
        <i
          class="fa-solid fa-circle-info ms-2"
          matTooltip="Selbstständige, Beamte und einige Berufsgruppen sind nicht gesetzlich rentenversicherungspflichtig."
          #tooltipRv="matTooltip"
          (click)="tooltipRv.show()"
        ></i>
      </div>

      <div class="mb-1">
        <mat-checkbox formControlName="gesetzlichArbeitslosenversichert">Gesetzlich arbeitslosenversichert</mat-checkbox>
        <i
          class="fa-solid fa-circle-info ms-2"
          matTooltip="Beamte und einige Berufsgruppen sind nicht arbeitslosenversicherungspflichtig."
          #tooltipAlv="matTooltip"
          (click)="tooltipAlv.show()"
        ></i>
      </div>

      <!-- Kinder -->
      <div class="mb-1">
        <mat-checkbox formControlName="kinderlos">Kinderlos (über 23 Jahre)</mat-checkbox>
        <i
          class="fa-solid fa-circle-info ms-2"
          matTooltip="Kinderlose Arbeitnehmer über 23 zahlen einen höheren Pflegeversicherungsbeitrag (+0,6%). Bist du unter 23 Jahre alt, deaktiviere diese Option – unabhängig davon, ob du Kinder hast."
          #tooltipKinderlos="matTooltip"
          (click)="tooltipKinderlos.show()"
        ></i>
      </div>

      @if (showKinderOptions) {
      <div class="row">
        <div class="col-12 col-xl-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Kinder unter 25</mat-label>
            <input formControlName="anzahlKinder" type="number" matInput placeholder="0" />
            <mat-icon matSuffix>
              <i
                class="fa-solid fa-circle-info ms-2"
                matTooltip="Ab dem zweiten Kind unter 25 Jahren reduziert sich der Pflegeversicherungsbeitrag um je 0,25% (bis max. 5 Kinder)."
                #tooltipKinder="matTooltip"
                (click)="tooltipKinder.show()"
              ></i>
            </mat-icon>
          </mat-form-field>
        </div>

        <div class="col-12 col-xl-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Kinderfreibeträge</mat-label>
            <mat-select formControlName="kinderfreibetraege">
              @for (kfb of kinderfreibetragOptions; track kfb) {
              <mat-option [value]="kfb">
                {{ kfb }}
              </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix class="ps-0">
              <i
                class="fa-solid fa-circle-info ms-2"
                matTooltip="Kinderfreibeträge reduzieren die Bemessungsgrundlage für Solidaritätszuschlag und Kirchensteuer (nicht die Lohnsteuer). Der Effekt ist nur sichtbar, wenn Soli anfällt (ab ca. 80.000 € Jahresbrutto) oder Kirchensteuer aktiviert ist."
                #tooltipKfb="matTooltip"
                (click)="tooltipKfb.show()"
              ></i>
            </mat-icon>
          </mat-form-field>
        </div>
      </div>
      }
      <!-- Eingaben merken -->
      <div>
        <mat-checkbox formControlName="rememberInputs">Eingaben merken</mat-checkbox>
      </div>
    </form>

    @if (this.selectedYearInfo()?.info) {
    <div class="alert alert-info" role="alert">
      {{ this.selectedYearInfo()?.info }}
    </div>
    }
  </div>
</div>
